/**
 * Created by lingcy on 2017/3/9.
 */
import React, {Component, PropTypes} from 'react';
import render from "react-dom";
import {Link, browserHistory} from "react-router";
import {ellaUrl} from '../../../path.config'
import extendsService from 'SERVICES/ella/extendsService'
import {resultTip,errorShow,errToSuc,language} from 'UTIL/common'
import Tip from 'COMPONENT/tip'
import FormInput from 'COMPONENT/form/formInput'
import FormSelect from 'COMPONENT/form/formSelect'
export default class RoleAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.userTypeId,
            nodeVos: [],
            userTypeId: this.props.params.userTypeId,
            formTypes: [],
            userType: "",
            url: ellaUrl
        };
    }

    componentDidMount() {
        var id = this.state.id;
        extendsService.initExtendsValue(id).then(data => {
            if (data.data != null) {
                $("#name").attr('disabled',true);
                $("#name").val(data.data.userType.name);
                this.setState({
                    formTypes: data.data.formTypes,
                    userType: data.data.userType,
                })
            }
        })
    }

    btnSubmit(event) {
        errToSuc();
        event.preventDefault();
        $("#btnSubmit").attr("disable",true)
        var formType = $("#formType option:selected").val();
        var attributeCode = $.trim($("#attributeCode").val());
        var attributeName = $.trim($("#attributeName").val());
        var attributeValue = $.trim($("#attributeValue").val());
        var errorMessage = '';
        if(attributeCode == ''){
            errorShow('attributeCode');
        }
        if(attributeName == ''){
            errorShow('attributeName');
        }
        if(attributeValue == ''){
            errorShow('attributeValue');
        }
        if($("[name='error']").length == 0){
            var data = {
                formType: formType,
                userTypeId:this.state.userType.id,
                attributeCode: attributeCode,
                attributeName: attributeName,
                attributeValue: attributeValue,
                remark: $("#remark").val(),
            };
            var extendsValue = JSON.stringify(data);
            extendsService.saveExtendsValue({extendsValue}).then(data =>{
                console.log(data)
                resultTip(data,"/ella/user/userType/extendsValue/" + this.state.userTypeId);
            })
        }

    }

    render() {
        var formType = this.state.formTypes;
        var formTypeList =[];
        var options;
        if (formType != null && formType.length !=0) {
            for( let index in formType){
                var type = {id:index,name:formType[index]}
                formTypeList.push(type);
            }
            options = formTypeList.map(function (index) {
                return <option key={index.id} value={index.id}>{index.name}</option>
            })
        }


        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['userType']}
                        <small>{language()['userTypeAdd']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['userTypeAdd']}</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <form className="form-horizontal">
                                <FormInput name="userTypeName" id="name"/>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()['formType']}</label>
                                    <div className="col-xs-3">
                                        <select id="formType" className="form-control">
                                            {options}
                                        </select>
                                    </div>
                                </div>
                                <FormInput name="extendedCoding" id="attributeCode"/>
                               <FormInput name="extendedName" id="attributeName"/>
                                <FormInput name="defaultAttributeValue" id="attributeValue"/>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()['remark']}</label>
                                    <div className="col-xs-3">
                                        <textarea id="remark" className="form-control"></textarea>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-xs-2"></div>
                                    <div className="col-xs-1 text-center">
                                        <button id="btnSubmit" className="btn btn-success" onClick={this.btnSubmit.bind(this)}>{language()['submit']}</button>
                                    </div>
                                    <div className="col-xs-1 text-center">
                                        <Link to={"/ella/user/userType/extendsValue/" + this.state.userTypeId}
                                              className="btn btn-default btn-md">
                                            {language()['return']}
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/userType/extendsValueAdd.js